import {
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Skeleton } from '@/components/ui/skeleton'

export const ToggleJitDialogFallback = () => {
  return (
    <>
      <AlertDialogHeader>
        <AlertDialogTitle>
          <Skeleton className="h-7 w-40" />
        </AlertDialogTitle>
        <AlertDialogDescription />
        <div>
          <Skeleton className="h-3 w-full mb-1" />
        </div>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Skeleton className="h-9 w-20" />
        <Skeleton className="h-9 w-23" />
      </AlertDialogFooter>
    </>
  )
}
